/*
 * COLMATA — abertura automática do carrinho lateral
 *
 * Horizon adiciona o item e atualiza o ícone do cabeçalho, mas não abre a gaveta.
 * Este script escuta o evento que o tema dispara ao alterar as linhas do carrinho
 * e abre a gaveta lateral.
 *
 * O botão "Comprar agora" NAO passa por aqui: ele faz um POST nativo para
 * /cart/add com return_to=/checkout, ou seja, sai da página antes de qualquer
 * evento de JS. Por isso vai direto ao checkout, sem abrir a gaveta.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 60;
  var opening = false;

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function openDrawer() {
    var d = drawer();
    if (!d || typeof d.open !== 'function') return;
    if (d.isOpen) return;
    try {
      d.open();
    } catch (e) {
      /* nunca quebrar a página por causa da gaveta */
    }
  }

  function onCartChange(event) {
    // Ignora remoções e alterações feitas dentro da própria gaveta.
    var d = drawer();
    if (d && d.isOpen) return;

    var target = event && event.target;
    if (target && target.closest && target.closest('#cart-drawer')) return;
    if (target && target.closest && target.closest('cart-items-component')) return;

    if (opening) return;
    opening = true;
    window.setTimeout(function () {
      opening = false;
      openDrawer();
    }, OPEN_DELAY);
  }

  document.addEventListener('shopify:cart:lines-update', onCartChange, true);

  // Rede de segurança: alguns fluxos (quick add) disparam nomes alternativos.
  ['cart:update', 'cart:refresh', 'shopify:cart:update'].forEach(function (name) {
    document.addEventListener(name, onCartChange, true);
  });
})();
